export const getCurrentAnsweredQuestionId = ({
	exerciseNextReducer: { currentAnsweredQuestionId },
}) => currentAnsweredQuestionId;
export const getExerciseDone = ({ exerciseNextReducer: { exerciseDone } }) => exerciseDone;
export const isLoading = ({ exerciseNextReducer: { loading } }) => loading;
